import { SupabaseClient } from '@supabase/supabase-js'
import { Database } from 'types/supabase'
import { MAX_RECIPIENTS } from './const'
import { processRequest, returnResponseError } from './request'
import { supabaseClient } from './supabase'

export const listRecipients = async (note_id: string) => {
  return processRequest(
    supabaseClient.from('recipients').select('*').eq('note_id', note_id)
    // supabaseClient.rpc("get_recipients", note_id)
  )
}

export const getSingleRecipient = async (recipient_id: string) => {
  return processRequest(
    supabaseClient.from('recipients').select('*').eq('id', recipient_id)
  )
}

export const deleteSingleRecipient = async (recipient_id: string) => {
  return processRequest(
    supabaseClient.from('recipients').delete().eq('id', recipient_id)
  )
}

type RecipientInsertData = {
  email?: string
  name?: string | null | undefined
  phone?: string | null | undefined
  country?: string | null | undefined
  country_code?: number | null | undefined
  message?: string | null | undefined
  full_phone?: string | null | undefined
  deliver_by: string | null | undefined
}

export const canAddMoreRecipients = async (note_id: string) => {
  const { data } = await processRequest(
    // @ts-ignore
    supabaseClient.rpc('can_add_more_recipients', {
      note_id: note_id,
      max_limit: MAX_RECIPIENTS,
    })
  )

  return data
}

export const addRecipient = async (
  note_id: string,
  data: RecipientInsertData,
  client?: SupabaseClient
) => {
  const supa = client ?? supabaseClient
  const {
    email,
    name,
    phone,
    country,
    message,
    full_phone,
    deliver_by,
    country_code,
  } = data

  const canAddMore = await canAddMoreRecipients(note_id)
  if (!canAddMore) return returnResponseError('max_limit_reached')

  return processRequest(
    // @ts-ignore
    supa
      .from('recipients')
      .insert({
        name: name,
        phone: phone,
        email: email,
        note_id: note_id,
        message: message,
        country: country,
        deliver_by: deliver_by,
        full_phone: full_phone,
        country_code: country_code,
      })
      .select('id')
      .limit(1)
      .single()
  )
}

type RecipientUpdateData = Database['public']['Tables']['recipients']['Update']
export const updateRecipient = async (
  id: string,
  data: RecipientUpdateData
) => {
  return processRequest(
    supabaseClient
      .from('recipients')
      // @ts-ignore
      .update(data)
      .eq('id', id)
  )
}
